import React from 'react'
import { useInViewOnce } from '../../Utilities/Observer';


const Premi = () => {
    const [ref, visible] = useInViewOnce();

  return (
    <section id='premi' className='w-screen bg-brand-black px-6 md:px-8 xl:px-[8vw] pt-12 sm:pt-16 lg:pt-24 sm:pb-12'>
        <article>
            <p className='font-mono text-brand-blue uppercase'>// Prizes</p>
            <h2 className='uppercase text-brand-white font-display font-black text-5xl sm:text-[clamp(2.4rem,6vw,6.5rem)] leading-none'>PRIZES</h2>
        </article>

        <article 
            ref={ref}
            className={`grid sm:grid-cols-3 py-12 lg:py-20 gap-6 sm:gap-8 transition-all duration-700 ease-out ${
            visible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}
        >
            <article 
                className='border border-brand-white/40 hover:border-brand-blue 
                duration-300 hover:-translate-y-3 rounded-md flex flex-col 
                justify-between p-8 gap-24'
            >
                <h4 className='text-7xl font-black text-brand-blue font-display'>01</h4>
                <div>
                    <h5 className='text-2xl font-black text-brand-white font-display uppercase'>1st place</h5>
                    <p className='uppercase text-brand-blue font-mono text-md font-medium'>Prize</p>
                </div>
            </article>
            <article className='border border-brand-white/40 hover:border-brand-blue duration-300 hover:-translate-y-3 rounded-md flex flex-col justify-between p-8 gap-24'>
                <h4 className='text-7xl font-black text-brand-blue font-display'>02</h4>
                <div>
                    <h5 className='text-2xl font-black text-brand-white font-display uppercase'>2nd place</h5>
                    <p className='uppercase text-brand-blue font-mono text-md font-medium'>Prize</p>
                </div>
            </article>
            <article className='border border-brand-white/40 hover:border-brand-blue duration-300 hover:-translate-y-3 rounded-md flex flex-col justify-between p-8 gap-24'>
                <h4 className='text-7xl font-black text-brand-blue font-display'>03</h4>
                <div>
                    <h5 className='text-2xl font-black text-brand-white font-display uppercase'>3rd place</h5>
                    <p className='uppercase text-brand-blue font-mono text-md font-medium'>Prize</p>
                </div>
            </article>
        </article>
    </section>
  )
}

export default Premi